import React from "react";
import PropTypes from "prop-types";
import { isEqual } from "underscore";
import CreditCardDetails from "components/CreditCardDetails";
import PaymentProviderChooser from "components/PaymentProviderChooser";
import PayPalButton from "components/PayPalButton";
import PayPalManager from "lib/PayPalManager";
import StripeManager from "lib/StripeManager";

const PaymentDetails = ({
  amount,
  cardNumber,
  cvv,
  errors,
  expiry,
  fieldsActive,
  frequency,
  locale,
  onChange,
  paymentProvider,
  payPalManager,
  stripeManager,
  submitActive,
  valid,
}) => {
  let chooser = "";
  let creditCard = "";
  let paypal = "";
  if (payPalManager.allowed && stripeManager.available) {
    chooser = (
      <PaymentProviderChooser
        active={fieldsActive}
        onChange={onChange}
        paymentProvider={paymentProvider}
      />
    );
  }
  if (stripeManager.available && paymentProvider === "credit_card") {
    creditCard = (
      <CreditCardDetails
        amount={amount}
        cardNumber={cardNumber}
        cvv={cvv}
        errors={errors}
        expiry={expiry}
        fieldsActive={fieldsActive}
        frequency={frequency}
        onChange={onChange}
        submitActive={submitActive}
      />);
  }
  if (payPalManager.allowed) {
    paypal = (
      <PayPalButton
        disabled={!submitActive}
        error={errors.paypal}
        frequency={frequency}
        locale={locale}
        paymentProvider={paymentProvider}
        payPalManager={payPalManager}
        preventDefault={!valid}
      />
    );
  }
  return (
    <React.Fragment>
      {chooser}
      {creditCard}
      {paypal}
    </React.Fragment>
  );
};

PaymentDetails.defaultProps = {
  amount: undefined,
  cardNumber: false,
  cvv: false,
  errors: {},
  expiry: false,
  fieldsActive: true,
  frequency: "once",
  locale: "en",
  onChange: () => {},
  paymentProvider: "credit_card",
  payPalManager: new PayPalManager({ }),
  stripeManager: new StripeManager({ }),
  submitActive: true,
  valid: true,
};

PaymentDetails.propTypes = {
  amount: PropTypes.string,
  cardNumber: PropTypes.bool,
  cvv: PropTypes.bool,
  errors: PropTypes.shape({
    address: PropTypes.string,
    amount: PropTypes.string,
    cardNumber: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    cvv: PropTypes.string,
    email: PropTypes.string,
    expiry: PropTypes.string,
    frequency: PropTypes.string,
    giftAid: PropTypes.string,
    lastName: PropTypes.string,
    name: PropTypes.string,
    payment_error: PropTypes.string,
    paypal: PropTypes.string,
    postcode: PropTypes.string,
    state: PropTypes.string,
    title: PropTypes.string,
  }),
  expiry: PropTypes.bool,
  fieldsActive: PropTypes.bool,
  frequency: PropTypes.oneOf(["once", "monthly"]),
  locale: PropTypes.string,
  onChange: PropTypes.func,
  paymentProvider: PropTypes.oneOf(["credit_card", "paypal"]),
  payPalManager: PropTypes.instanceOf(PayPalManager),
  stripeManager: PropTypes.instanceOf(StripeManager),
  submitActive: PropTypes.bool,
  valid: PropTypes.bool,
};

export default React.memo(
  PaymentDetails,
  (prevProps, nextProps) => isEqual(prevProps, nextProps)
);
